













import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class SFKnob extends Vue {
    @Prop({required: true, default: 0}) value!: number;
    @Prop({required: false, default: '#17d'}) color!: string;
    @Prop({required: false}) afterValue!: string;
    @Prop({required: false, default: '#d2d3d4'}) background!: string;
    @Prop({required: false, default: 'transform: translate(0,0)'}) labelStyle!:string;

    get strokeDasharray() {
        if (this.value <= 0) {
            let value = 0;
            return value + ' ' + (94 - value);
        } else {
            let value = this.value * 94 / 100;
            return value + ' ' + (94 - value);
        }
    }
}
